import {
  Directive,
  ElementRef,
  AfterContentChecked,
  Renderer2,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { isNoDesktop } from '../helpers';

@Directive({
  selector: '[appHeightGenerator]',
})
export class HeightGeneratorDirective
  implements AfterContentChecked, OnInit, OnDestroy {
  lastContentHeight = 0;
  lastDocumentSize = 0;
  shouldResize = true;
  private subscriptions: Subscription[] = [];

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit() {
    const sub = fromEvent(window, 'resize')
      .pipe(debounceTime(250))
      .subscribe(() => {
        if (!isNoDesktop()) {
          this.updateScroll();
        } else {
          this.renderer.setStyle(this.element.nativeElement, 'height', `auto`);
        }
      });
    this.subscriptions.push(sub);
  }

  ngAfterContentChecked() {
    const currentContentSize = this.getContentSize();
    if (currentContentSize === 0 || isNoDesktop()) {
      return;
    }

    if (this.lastContentHeight !== currentContentSize) {
      this.updateScroll();
    }

    if (!this.shouldResize) {
      return;
    }

    this.renderer.setStyle(this.element.nativeElement, 'height', `auto`);
    if (
      this.lastDocumentSize !== document.body.scrollHeight &&
      this.lastDocumentSize !== 0
    ) {
      this.shouldResize = false;
    }
    this.lastDocumentSize = document.body.scrollHeight;
    this.setHeight(this.getHeight());
    this.lastContentHeight = this.getContentSize();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(_ => _.unsubscribe());
  }

  updateScroll() {
    this.renderer.setStyle(this.element.nativeElement, 'height', `auto`);
    this.setHeight(this.getHeight());
    this.lastContentHeight = this.getContentSize();
  }

  getContentSize(): number {
    return this.element.nativeElement.querySelector('.ps-content').offsetHeight;
  }

  getHeight(): number {
    const e = this.element.nativeElement;
    const prevheight =
      window.innerHeight - (document.body.scrollHeight - e.offsetHeight);
    return prevheight < 300 ? 300 : prevheight;
  }

  setHeight(height: number) {
    this.renderer.setStyle(this.element.nativeElement, 'height', `${height}px`);
  }
}
